import { Typography } from "@mui/material";
import {
  useGridApiContext,
  useGridSelector,
  gridSortedRowEntriesSelector,
  GridToolbarContainer,
  GridToolbarExport,
  type GridCsvExportOptions,
  gridSortedRowIdsSelector,
} from "@mui/x-data-grid";
import moment from "moment";

import { usePclContext } from "../../context/PclContextProvider";

const HIDDEN_EXPORT_FIELDS = ["_actions"];

export const PclToolbar = () => {
  const apiRef = useGridApiContext();
  const filteredRows = useGridSelector(apiRef, gridSortedRowEntriesSelector);
  const {
    filters: { status },
  } = usePclContext();

  const columns = apiRef.current.getVisibleColumns();
  const fieldsForExport = [
    ...columns.map((col) => col.field),
    "tech_types",
  ].filter((field) => !HIDDEN_EXPORT_FIELDS.includes(field));

  const csvOptions: GridCsvExportOptions = {
    fields: fieldsForExport,
    fileName: moment().format(`[PCL_Export_${status}]_MMMM_DD_YYYY`),
    // This exports all rows regardless of filtering or pagination
    // There are several other utils available: https://v7.mui.com/x/react-data-grid/export/#exported-rows
    getRowsToExport: ({ apiRef }) => gridSortedRowIdsSelector(apiRef),
  };

  return (
    <GridToolbarContainer
      sx={{
        padding: "1em",
        justifyContent: "space-between",
      }}
    >
      <Typography variant="h6">
        Showing: {filteredRows.length || 0} Matches
      </Typography>

      <GridToolbarExport csvOptions={csvOptions} />
    </GridToolbarContainer>
  );
};
